import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Eyebrow } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";
import { StoreButtons } from "./StoreButtons";
import { HeroVisual } from "./HeroVisual";
import { Countdown } from "./Countdown";

const fade = (d) => ({ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "8%"]);
  const textY = useTransform(scrollYProgress, [0, 1], [0, 120]);

  return (
    <section id="top" ref={ref} className="relative overflow-hidden pb-24 pt-32 sm:pt-40 lg:pb-32" data-testid="hero-section">
      <div className="pointer-events-none absolute -left-40 top-20 h-[520px] w-[520px] rounded-full bg-[#F4DED3] blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-[#E9D5C0] opacity-70 blur-3xl" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-[1.15fr_1fr] lg:gap-10 lg:px-12">
        <motion.div style={{ y: textY }} className="min-w-0">
          <motion.div {...fade(0.1)}><Eyebrow>Cycle & lifestyle, in one rhythm</Eyebrow></motion.div>
          <h1 className="mt-8 font-serif text-[3.2rem] font-light leading-[0.95] tracking-[-0.02em] text-[#2C221E] sm:text-7xl lg:text-[6.2rem]" data-testid="hero-title">
            <MaskLines lines={[
              <>Every phase</>,
              <>of you, <em className="font-normal italic text-[#9E4429]">held</em></>,
              <>with grace.</>,
            ]} />
          </h1>
          <motion.p {...fade(0.75)} className="mt-8 max-w-lg text-base leading-relaxed text-[#5C4A42] sm:text-lg">
            Lunelle is a cycle and lifestyle app. It follows every phase of your cycle, then shapes what you eat, what you wear,
            how you spend and the word you start your day with around it.
          </motion.p>
          <motion.div {...fade(0.95)} className="mt-10 space-y-5">
            <Countdown prefix="hero" />
            <WaitlistForm prefix="hero" />
            <StoreButtons prefix="hero" />
          </motion.div>
          <motion.p {...fade(1.15)} className="mt-8 text-xs uppercase tracking-[0.2em] text-[#7A665C]">
            Launching on iOS & Android · Free to start
          </motion.p>
        </motion.div>
        <HeroVisual parallaxY={imgY} />
      </div>
    </section>
  );
};
